import { render } from "./manageList.vue?vue&type=template&id=10d0d660&scoped=true"
import script from "./manageList.vue?vue&type=script&lang=js"
export * from "./manageList.vue?vue&type=script&lang=js"

import "./manageList.vue?vue&type=style&index=0&id=10d0d660&lang=scss&scoped=true"
import "./manageList.vue?vue&type=style&index=1&id=10d0d660&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d0d660"]])

export default __exports__